var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranchiseCat14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.002,
    height: 26.609,
    viewBox: "0 0 30.002 26.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "franchise",
    transform: "translate(-1.998 -5.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87742",
    "data-name": "Path 87742",
    d: "M19.5,16.805a.5.5,0,0,0,0,1h12a.5.5,0,0,0,0-1h-.08v-4.64c.05-.05.1-.1.145-.155a1.757,1.757,0,0,0,.41-1.435L31.22,5.81a.5.5,0,0,0-.5-.42H20.275a.5.5,0,0,0-.5.42l-.755,4.765a1.757,1.757,0,0,0,.41,1.435c.045.055.095.1.145.155V16.8ZM26,6.39h1.65L28,10.86a.764.764,0,0,1-.22.525,1.041,1.041,0,0,1-.775.325H27a.935.935,0,0,1-1-.86Zm4.3,0,.69,4.345a.768.768,0,0,1-.185.625,1.029,1.029,0,0,1-.15.145.175.175,0,0,0-.04.025,1.094,1.094,0,0,1-.61.18.946.946,0,0,1-.99-.8L29,10.735,28.655,6.39H30.3ZM25,10.85a.935.935,0,0,1-1,.86H23.99a1.041,1.041,0,0,1-.775-.325.764.764,0,0,1-.22-.525c0-.025.005-.045.005-.07l.35-4.4H25Zm-4.99-.115L20.7,6.39h1.645L22,10.71v.025l-.015.175a.946.946,0,0,1-.99.8,1.094,1.094,0,0,1-.61-.18.175.175,0,0,0-.04-.025,1.029,1.029,0,0,1-.15-.145A.768.768,0,0,1,20.01,10.735Z",
    transform: "translate(-8.501)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87743",
    "data-name": "Path 87743",
    d: "M2.5,46.195h12a.5.5,0,1,0,0-1h-.08V40.56c.05-.05.1-.1.145-.155a1.8,1.8,0,0,0,.41-1.435l-.755-4.765a.5.5,0,0,0-.495-.425H3.274a.5.5,0,0,0-.495.425l-.76,4.765A1.782,1.782,0,0,0,2.434,40.4c.045.055.1.105.145.155v4.635H2.5a.5.5,0,0,0,0,1ZM9,34.78h1.65L11,39.19a.783.783,0,0,1-.215.59,1.06,1.06,0,0,1-.775.325H9.994A.935.935,0,0,1,9,39.245Zm4.3,0,.69,4.35a.768.768,0,0,1-.185.625,1.029,1.029,0,0,1-.15.145.125.125,0,0,0-.035.02,1.087,1.087,0,0,1-.615.185.946.946,0,0,1-.99-.8l-.36-4.525ZM8,39.245a.935.935,0,0,1-.995.86H6.989a1.051,1.051,0,0,1-.775-.325.8.8,0,0,1-.22-.53c0-.02.005-.045.005-.065l.35-4.4H8Zm-4.99-.12L3.7,34.78H5.344L5,39.105v.02l-.015.18a.946.946,0,0,1-.99.8,1.094,1.094,0,0,1-.61-.18.175.175,0,0,0-.04-.025,1.029,1.029,0,0,1-.15-.145A.774.774,0,0,1,3.009,39.125Z",
    transform: "translate(0 -14.195)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87744",
    "data-name": "Path 87744",
    d: "M48.5,45.195h-.08V40.56c.05-.05.1-.1.145-.155a1.782,1.782,0,0,0,.415-1.435l-.76-4.765a.5.5,0,0,0-.495-.425H37.275a.5.5,0,0,0-.495.425l-.755,4.765a1.8,1.8,0,0,0,.41,1.435c.045.055.095.105.145.155v4.635H36.5a.5.5,0,1,0,0,1h12a.5.5,0,0,0,0-1ZM47.3,34.78l.69,4.345a.773.773,0,0,1-.185.63,1.029,1.029,0,0,1-.15.145.175.175,0,0,0-.04.025,1.094,1.094,0,0,1-.61.18.946.946,0,0,1-.99-.8L46,39.125l-.345-4.345ZM43,39.245V34.78h1.65l.355,4.47a.8.8,0,0,1-.22.53,1.051,1.051,0,0,1-.775.325H44A.935.935,0,0,1,43,39.245Zm-1,0a.935.935,0,0,1-.995.86H40.99a1.06,1.06,0,0,1-.775-.325A.783.783,0,0,1,40,39.19v-.005l.35-4.405H42Zm-4.99-.12.69-4.345h1.645l-.36,4.525a.946.946,0,0,1-.99.8,1.087,1.087,0,0,1-.615-.185.125.125,0,0,0-.035-.02,1.029,1.029,0,0,1-.15-.145A.774.774,0,0,1,37.01,39.125Z",
    transform: "translate(-17.001 -14.195)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87745",
    "data-name": "Path 87745",
    d: "M49.012,26.259a.5.5,0,0,0,.5-.5V21.537a.5.5,0,0,0-.5-.5H46.519a.5.5,0,0,0,0,1h1.993v3.722A.5.5,0,0,0,49.012,26.259Z",
    transform: "translate(-22.011 -7.824)",
    fill: "#85899c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87746",
    "data-name": "Path 87746",
    d: "M11.423,21.037a.5.5,0,0,0-.5.5v4.222a.5.5,0,1,0,1,0V22.037h1.993a.5.5,0,0,0,0-1Z",
    transform: "translate(-4.463 -7.824)",
    fill: "#85899c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranchiseCat14);
export default __webpack_public_path__ + "static/media/franchise_cat_14.e571029b80277af61438dd0cc26b7f66.svg";
export { ForwardRef as ReactComponent };